import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
var rule = [{
  key: 'province',
  name: '省份'
}, {
  key: 'details',
  name: '详细地址'
}, {
  key: 'phoneNumber',
  name: '联系电话',
  validator: 'validatePhone'
}, {
  key: 'contactName',
  name: '联系人'
}];
export default {
  meta: {
    title: '新增退货地址',
    auth: true,
    authorityValue: "store-delivery-refund"
  },
  name: 'addReturnShop',
  data: function data() {
    return {
      // 表单
      formData: {
        province: '',
        city: '',
        district: '',
        details: '',
        postCode: '',
        phoneNumber: '',
        contactName: '',
        defaultAddress: false,
        addressType: 1
      },
      // 表单校验
      rules: utilRules(rule)
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 3;
                  return _this.$api.saveAddress(_this.formData);

                case 3:
                  _this.$notify.success({
                    title: '成功',
                    message: '添加成功'
                  });

                  _this.goBack();

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.formData, 'province', e[0]);
      e[1] && this.$set(this.formData, 'city', e[1]);
      e[2] && this.$set(this.formData, 'district', e[2]);
      this.$refs.formData.validateField('province');
    }
  }
};